import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Toaster } from "./components/ui/toaster";
import HomePage from "./pages/HomePage";
import PortfolioDetailPage from "./pages/PortfolioDetailPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import SeoServicePage from "./pages/SeoServicePage";
import SupportPortal from "./pages/SupportPortal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/politique-de-confidentialite"
            element={<PrivacyPolicy />}
          />
          <Route path="/espace-client" element={<SupportPortal />} />
          <Route path="/portfolio/:slug" element={<PortfolioDetailPage />} />
          <Route path="/:slug" element={<SeoServicePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
